import { useLocation } from 'react-router';
import stringToDate from '../../../../function/stringToDate';
import LegMaterialListFilter from '../../../../model/legislativnyMaterial/LegMaterialListFilter';
import useValidPolozkyCiselnik from '../../../../hooks/usePolozkyCiselnik';
import useOrganizacie from '../../../../hooks/useOrganizacie';
import Uuid from '../../../../model/Uuid';
import { StadiumMaterialuEnum } from '../../../../model/legislativnyMaterial/StadiumMaterialu';
import useZodpovednyPredkladatel from '../../../../hooks/useZodpovednyPredkladatel';

// eslint-disable-next-line prefer-regex-literals
const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-f]{12}$/i;

const mapSearchText = (searchText: string): string => {
  if (searchText && searchText.trim().length > 0) {
    return searchText;
  }
  return '';
};

const getUuid = (uuid: string): Uuid => {
  if (uuid && uuid.match(uuidRegex)) {
    return uuid;
  }
  return null;
};

const typToKodArray = (typPredpis: string): string[] => {
  if (typPredpis?.trim()?.length > 0) {
    return [typPredpis];
  }
  return [];
};

const oblastListToKodyArray = (oblastList: string): string[] => {
  if (!oblastList) {
    return [];
  }

  return oblastList.split(',')
    .filter(item => !!item);
};

interface ReturnType {
  initialFilterLoading: boolean;
  initialFilterFinished: boolean;
  initialFilter: LegMaterialListFilter;
}

export default (): ReturnType => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);

  const oblastListKod = oblastListToKodyArray(search.get('oblastList'));
  const typKodArray = typToKodArray(search.get('typ'));
  const mergedKodyList = [...oblastListKod, ...typKodArray];
  const instituciaUuid = getUuid(search.get('institucia'));
  const predkladatelUuid = getUuid(search.get('predkladatel'));

  const {
    polozkyCiselnik,
    polozkyCiselnikStatus,
  } = useValidPolozkyCiselnik(
    [],
    undefined,
    undefined,
    mergedKodyList,
    mergedKodyList.length > 0,
  );

  const {
    organizacie,
    organizacieStatus,
  } = useOrganizacie(
    undefined,
    undefined,
    undefined,
    undefined,
    [instituciaUuid],
    instituciaUuid !== null,
  );

  const {
    pouzivatelia,
    pouzivateliaStatus,
  } = useZodpovednyPredkladatel(predkladatelUuid, predkladatelUuid !== null);

  return {
    initialFilter: polozkyCiselnik ? {
      datumZmenyOd: stringToDate(search.get('from')),
      datumZmenyDo: stringToDate(search.get('to')),
      stadium: search.get('stadium') == null ? null : StadiumMaterialuEnum[search.get('stadium')],
      typ: polozkyCiselnik.find(polozka => typKodArray.includes(polozka.kod)) || null,
      oblastList: polozkyCiselnik.filter(polozka => oblastListKod.includes(polozka.kod)),
      searchTextVyraz: mapSearchText(search.get('hladanyVyraz')),
      searchTextCislo: mapSearchText(search.get('cisloLegMaterialu')),
      searchTextRezort: mapSearchText(search.get('rezortCislo')),
      searchTextNazov: mapSearchText(search.get('nazov')),
      searchTextRocnik: mapSearchText(search.get('rocnik')),
      predkladatel: pouzivatelia?.length > 0 ? pouzivatelia[0] : null,
      institucia: organizacie?.length > 0 ? organizacie[0] : null,
    } : null,
    initialFilterLoading: polozkyCiselnikStatus.loading || organizacieStatus.loading || pouzivateliaStatus.loading,
    initialFilterFinished: polozkyCiselnikStatus.finished && organizacieStatus.finished && pouzivateliaStatus.finished,
  };
};
